// Download + Copy for a transcript — the live room (any time, even mid-meeting) and the archived
// meeting's Transcript tab (Claire, Oct 28 scrum: "is there a way to do a one-click download?").
import { useState } from "react";
import { copyText, downloadText } from "./download";
import "./transcriptActions.css";

export const TranscriptActions = ({ fileName, text }: { fileName: string; text: () => string }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    if (await copyText(text())) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };
  return (
    <span className="tx-actions">
      <button onClick={() => downloadText(fileName, text())} title="Download the transcript">Download</button>
      <button className="tx-copy" onClick={copy} title="Copy the transcript">{copied ? "Copied ✓" : "Copy"}</button>
    </span>
  );
};
